module.exports = __webpack_public_path__ + "static_portal/media/rowing_coach_lq.4d99809e.mp4";